export const ZOOM_LEVELS = [1, 1.5, 2.0, 2.5];
export const MIN_ZOOM = ZOOM_LEVELS[0];
export const MAX_ZOOM = ZOOM_LEVELS[ZOOM_LEVELS.length - 1];

export const DEFAULT_HEIGHT = 480;
export const MIN_HEIGHT = 152;
export const MAX_HEIGHT = 560;
